import { StaticPaths, Locales } from '@monoimin/sb-types';

import { getFolderSlugs } from '../storyblok/getFolderSlugs';

import { fillParamsWithLocaleSegment } from './fillParamsWithLocaleSegment';

type CreateFolderStaticParamsArgs = {
  /**
   * Папка сториблока, из которой будем делать параметры.
   */
  folder: string;
  /**
   * Определяем в каком виде вернуть параметр.
   */
  type?: 'array' | 'string';
  /**
   * Определяем ключ параметра. По умолчанию - slug.
   */
  key?: string;
  /**
   * Определяем локали.
   */
  locales?: Array<Locales>;
};

/**
 * Собираем из объектов links сториблока объекты для static params.
 * Если передаём массив locales, собираем данные из локализованных папок. Иначе берэм только из одной folder.
 */
export const createFolderStaticParams = async ({
  folder,
  type = 'string',
  key = 'slug',
  locales,
}: CreateFolderStaticParamsArgs): Promise<StaticPaths> => {
  if (Array.isArray(locales) && locales.length) {
    const params: Array<StaticPaths> = [];

    for (let i = 0; i < locales.length; i++) {
      const locale = locales[i];

      const folderParams = await createFolderStaticParams({
        type: type,
        folder: folder.replace('/locale/', `/${locale}/`),
      });

      params.push(fillParamsWithLocaleSegment(folderParams, locale));
    }

    return params.flat();
  }

  const folderSlugs = await getFolderSlugs(folder);

  return folderSlugs.map((item) => {
    return {
      [key]: type === 'array' ? [item] : item,
    };
  });
};

export default createFolderStaticParams;
